import React from 'react';

export default function ChatSidePanelProgressBlock({
  iconClass = '',
  label = '',
  valueClassName = '',
  fillClassName = '',
  percent = 0,
  loading = false,
  wrapperClassName = 'side-progress-block',
  headerClassName = 'side-progress-head side-progress-head--event-list',
  labelClassName = 'side-progress-label',
  trackClassName = 'event-card-progress-track',
}) {
  const safePercent = Math.min(100, Number(percent) || 0);
  return (
    <div className={wrapperClassName}>
      <div className={headerClassName}>
        <span className={labelClassName}>
          <i className={iconClass} aria-hidden="true"></i>
          <span>{label}</span>
        </span>
        <span className={valueClassName}>{loading ? '…' : `${safePercent}%`}</span>
      </div>
      <div className={trackClassName}>
        <div className={fillClassName} style={{ width: `${safePercent}%` }}></div>
      </div>
    </div>
  );
}
